export const CLASS_NAMES = {
  WRAPPER: "js-animateObserver",
  ITEM: "js-animate",
  ANIMATE: "is-animate",
};
